import Moment from 'moment';

import Config from './config/Config';

class Utils {
    static getLoginUrl() {
        return Config.mainHost + "login?return=" + this.urlEncode(Config.host);
    }
    
    static checkAvailability(array, value, setDefault = false) {
        if(array.indexOf(value) < 0){
            if(setDefault)
            return array[0];
            else
            return '';
        }else
        return value;
    }
    
    static checkUsage(value) {
        if(value != null && value !== '')
        return value;
        else
        return '';
    }
    
    static checkArray(value) {
        return Array.isArray(value);
    }
    
    static divideByThousands(value, thousandsGlue = ' ', decimalGlue = ',') {
        var parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsGlue);
        
        return parts.join(decimalGlue);
    }
    
    static jsonDecode(data) {
        return JSON.parse(data);
    }
    
    static urlEncode(value) {
        return encodeURIComponent(value);
    }
    
    static reloadPage(url) {
        url = url || '';
        
        if(url === '')
        window.location.reload();
        else
        window.top.location = url;
    }
    
    static checkResponse(data) {
        return (data.data.status && (data.status === 200 || data.status === 401));
    }
    
    static getAPIStatusLayout(value) {
        var data = {text: '', color: ''};
        
        switch(value) {
            case 'normal':
            data.text = 'Normal';
            data.color = 'Good';
            break;
            case 'unstable':
            data.text = 'Unstable';
            data.color = 'Medium';
            break;
            case 'down':
            data.text = 'Down';
            data.color = 'Bad';
            break;
            default:
        }
        
        return data;
    }
    
    static validateEmail(value) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
    }
    
    static validateIP(value) {
        var re = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        return re.test(String(value).toLowerCase());
    }
    
    static convertDate(value, withHour = false) {
        return Moment(value * 1000).format((withHour) ? Config.dateFormatHour : Config.dateFormat);
    }
}

export default Utils;